import Box from "@/main/components/shared/box";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import ModalImages from "@/main/components/shared/modalImages/modalImages";
import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import ResultNotFoundComponent from "@/main/components/shared/resultNotFound/resultNotFoundComponent";
import TypographyVehicle from "@/main/components/shared/typographyVehicle/typographyVehicle";
import AutofillReassign from "@/main/screens/order/reassignOrder/components/autofill/autofillReassign";
import ReassignPartItem from "@/main/screens/order/reassignOrder/components/reassignPartItem/reassignPartItem";
import SubmitBar from "@/main/screens/order/reassignOrder/components/submitBar/submitBar";
import useReassignScreen from "@/main/screens/order/reassignOrder/useReassignScreen";
import { KeyValueDefault } from "@/main/models/common";
import { getTranslateByKey } from "@/main/services/utils";
import { FormProvider } from "react-hook-form";
import { useState } from "react";
import * as S from "./styles";

interface IReassignScreen {
	isBulk: boolean;
}
const EMPTY_PART_TYPE_OPTIONS: KeyValueDefault[] = [];

export default function ReassignScreen({ isBulk }: Readonly<IReassignScreen>) {
	const [openModalImages, setOpenModalImages] = useState<boolean>(false);
	const {
		isLoadingGet,
		isLoadingSave,
		messageErrorScreen,
		partsData,
		guidCompanyBuyer,
		vehicleFullName,
		partTypeOptionsByQuote,
		guidClaimParams,
		methods,
		onSubmit,
		handleBack,
		titleScreen,
		showPrices,
		showEditControl,
		showAutofill,
		showImagesButton,
		showCanceledBySupplierWarning,
		ModalConfirmation,
	} = useReassignScreen(isBulk);
	const isClaimImagesMode = Boolean(guidClaimParams);
	const guidQuoteImages = isClaimImagesMode ? "" : (partsData[0]?.quoteGuid ?? "");
	const quoteItemGuidImages = partsData.length === 1 ? partsData[0]?.guidQuoteItem : undefined;

	if (isLoadingGet)
		return (
			<ContainerScreen title={titleScreen}>
				<LoadingComponent />
			</ContainerScreen>
		);

	if (messageErrorScreen)
		return (
			<ContainerScreen title={titleScreen}>
				<ResultNotFoundComponent withButtonBack messageCustom={messageErrorScreen} />
			</ContainerScreen>
		);

	if (partsData.length === 0)
		return (
			<ContainerScreen title={titleScreen}>
				<ResultNotFoundComponent withButtonBack />
			</ContainerScreen>
		);

	return (
		<ContainerScreen title={titleScreen}>
			<S.Container>
				<S.AreaMain>
					<Box style={{ backgroundColor: "white", borderRadius: "unset" }}>
						<S.HeaderScreen>
							{vehicleFullName && <TypographyVehicle manufacturer={vehicleFullName} />}
							{showImagesButton && (
								<S.HeaderActions>
									<SecondaryButton
										id="id-reassignOrder-btn-images"
										type="button"
										onClick={() => setOpenModalImages(true)}
									>
										{getTranslateByKey("information.images")} / {getTranslateByKey("information.files")}
									</SecondaryButton>
								</S.HeaderActions>
							)}
						</S.HeaderScreen>

						{showAutofill && showEditControl && (
							<AutofillReassign
								partsData={partsData}
								partTypeOptionsByQuote={partTypeOptionsByQuote}
								guidCompanyBuyer={guidCompanyBuyer}
								mainForm={methods}
							/>
						)}

						<FormProvider {...methods}>
							<form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
								{partsData.map((part, index) => (
									<ReassignPartItem
										key={part.guidOriginalProcurementSupplierItem}
										index={index}
										partData={part}
										showPrices={showPrices}
										guidCompanyBuyer={guidCompanyBuyer}
										partTypeOptions={partTypeOptionsByQuote[part.quoteGuid ?? ""] ?? EMPTY_PART_TYPE_OPTIONS}
										showEditControl={showEditControl}
										showHeader={index === 0}
										showCanceledBySupplierWarning={showCanceledBySupplierWarning}
									/>
								))}

								<SubmitBar control={methods.control} isLoadingSave={isLoadingSave} onBack={handleBack} />
							</form>
						</FormProvider>
					</Box>
				</S.AreaMain>
			</S.Container>

			<ModalConfirmation />

			{showImagesButton && (
				<ModalImages
					isOpenModal={openModalImages}
					closeModal={() => setOpenModalImages(false)}
					setIsOpenModal={setOpenModalImages}
					canUploadImages={true}
					canShowPDF={true}
					guidQuote={guidQuoteImages}
					guidClaim={guidClaimParams ?? ""}
					quoteItemGuid={quoteItemGuidImages}
					canRelateToGeneralOrder={!isClaimImagesMode}
					canDownloadImages={true}
				/>
			)}
		</ContainerScreen>
	);
}
